/** Shared UI helpers */
export function formatDate(iso: string | null | undefined, lang = 'ru'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatMoney(amount: string | number, lang = 'ru'): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(n)) return String(amount);
  return lang === 'ru' ? `${n.toFixed(0)} ₽` : `$${n.toFixed(2)}`;
}

export function subStatusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'Активна';
    case 'expired':
      return 'Истекла';
    default:
      return 'Нет';
  }
}

export function subStatusClass(status: string): string {
  switch (status) {
    case 'active':
      return 'badge badge-success';
    case 'expired':
      return 'badge badge-warning';
    default:
      return 'badge badge-muted';
  }
}
